import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../../commonComponents/translate';
import {
  GAME_EVENT_TYPE,
  TROPHY_CONFIG,
} from '../../../../services/utilityFunctions';
import GameEventProp from '../../propTypes/gameEventProp';
import RankingItem from './RankingItem';
import DefaultItem from './DefaultItem';
import TimelineItemContainer from '../../../../commonComponents/timeline/TimelineItemContainer';
import TimelineItemFooter from './TimelineItemFooter';

function TimelineItem({ t, side, isFirst, event, onAddLike, onAddComment }) {
  const date = moment.utc(event.date).format('DD MMM, YY - HH:mm');
  let title = t(`challengeDetails_eventTitle_${event.type}`);
  if (event.type === GAME_EVENT_TYPE.TROPHY && event.trophy) {
    const trophyConfig = TROPHY_CONFIG[event.trophy.type] || {};
    title += `: ${t(trophyConfig.translationKey)}`;
  }

  return (
    <TimelineItemContainer
      side={side}
      isFirst={isFirst}
      date={date}
      title={title}
      footer={
        <TimelineItemFooter
          event={event}
          onCommentClick={onAddComment}
          onLikeClick={onAddLike}
        />
      }
    >
      {event.type === GAME_EVENT_TYPE.RANKING_POSITION ? (
        <RankingItem user1={event.user1} user2={event.user2} />
      ) : (
        <DefaultItem event={event} />
      )}
    </TimelineItemContainer>
  );
}

TimelineItem.propTypes = {
  t: PropTypes.func.isRequired,
  event: PropTypes.shape(GameEventProp.propType).isRequired,
  side: PropTypes.oneOf(['left', 'right']).isRequired,
  isFirst: PropTypes.bool.isRequired,
  onAddLike: PropTypes.func.isRequired,
  onAddComment: PropTypes.func.isRequired,
};

export default translate(TimelineItem);
